import { synopsisParagraphs, viewingGuide } from '@/mocks/russianMom';

export default function SynopsisSection() {
  return (
    <section id="synopsis" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-book-open-line" aria-hidden="true"></i>
              剧情简介
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一场从陌生到熟悉的家庭长旅
            </h2>
            <div className="mt-6 space-y-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
              {synopsisParagraphs.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <i className="ri-heart-3-line text-xl text-primary-500" aria-hidden="true"></i>
                <p className="mt-2 font-heading text-lg font-bold text-foreground-950">克制</p>
                <p className="mt-1 text-xs text-foreground-600">不煽情，情绪藏在日常细节里</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <i className="ri-global-line text-xl text-secondary-500" aria-hidden="true"></i>
                <p className="mt-2 font-heading text-lg font-bold text-foreground-950">跨文化</p>
                <p className="mt-1 text-xs text-foreground-600">语言与习惯的碰撞与磨合</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <i className="ri-home-heart-line text-xl text-accent-600" aria-hidden="true"></i>
                <p className="mt-2 font-heading text-lg font-bold text-foreground-950">生活流</p>
                <p className="mt-1 text-xs text-foreground-600">餐桌与厨房撑起整部剧的骨架</p>
              </div>
            </div>
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-compass-3-line text-secondary-500" aria-hidden="true"></i>
              四步观看指南
            </h3>
            <p className="mt-2 text-xs text-foreground-600">第一次访问本站，可以按下面的顺序浏览。</p>
            <ol className="mt-5 space-y-4">
              {viewingGuide.map((g) => (
                <li key={g.id} className="flex gap-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-foreground-950">
                    {g.step}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{g.title}</p>
                    <p className="mt-1 text-xs leading-6 text-foreground-600">{g.text}</p>
                  </div>
                </li>
              ))}
            </ol>
            <a
              href="#episodes"
              className="mt-6 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              前往分集列表
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}